    <!-- CUSTOM DISPLAY ORDRE DE MALTE -->
<div class="table-wrapper">


  <table *ngIf="kidsDatas.length > 0" mat-table [dataSource]="kidsDatas" class="mat-elevation-z8">

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date/Heure </th>
      <td mat-cell *matCellDef="let element"> {{element.timestamp | date: 'dd MMMM yyyy HH:mm:ss'}} </td>
    </ng-container>


    <ng-container matColumnDef="kidName">
      <th mat-header-cell *matHeaderCellDef>Nom de l'enfant </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>


    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef> Nom de l'intervenant </th>
      <td mat-cell *matCellDef="let element"> {{element.userName}}</td>
    </ng-container>


    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Type d'action </th>
      <td mat-cell *matCellDef="let element"> {{element.action}} </td>
    </ng-container>

    <ng-container matColumnDef="signature">
      <th mat-header-cell *matHeaderCellDef>Signature </th>
      <td mat-cell *matCellDef="let element"> <img [src]="element.signatureURL" alt=""> </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="diplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: diplayedColumns;"></tr>
  </table>
</div>
